module.exports = __webpack_public_path__ + "img/4-Integras-Live-Chat-Page-MVP.047f637d.png";